var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReddit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4267B2;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#C2191E;}\n\t.st4{fill:#1DA1F3;}\n\t.st5{fill:#FEFE00;}\n\t.st6{fill:#25D366;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}\n\t.st7{fill:#CB2027;}\n\t.st8{fill:#0077B5;}\n\t.st9{fill:url(#SVGID_2_);}\n\t.st10{fill:url(#SVGID_3_);}\n\t.st11{fill:#FF004F;}\n\t.st12{fill:#00F7EF;}\n\t.st13{fill:#5181B8;}\n\t.st14{fill:#395976;}\n\t.st15{fill:#F58220;}\n\t.st16{fill:#E6162D;}\n\t.st17{fill:#FF9933;}\n\t.st18{fill:#FF4500;}\n\t.st19{fill:#0F88EB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guidlines"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "FB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ig"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "yt"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "snapchat"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "WA"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Pinterrest"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 32,
    cy: 32,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52,32c0-2.210022-1.789978-4-4-4c-1.4500122,0-2.7199707,0.7699585-3.4199829,1.9299927    c-2.8978882-2.2456055-6.9917603-3.7012939-11.5726929-3.8917847l1.8012695-10.8057861l6.9492188,1.7373047    c0.0822754,0.020813,0.1628418,0.0117188,0.2440796,0.0114746C42.0018311,16.9876099,42,16.9935303,42,17    c0,1.6568604,1.3431396,3,3,3s3-1.3431396,3-3s-1.3431396-3-3-3c-0.9818726,0-1.845459,0.4785156-2.3927612,1.2077026    c-0.1055298-0.0809326-0.2277832-0.1431885-0.3650513-0.1774292l-8-2    c-0.2714844-0.0703125-0.5566406-0.0205078-0.7900391,0.1337891c-0.2333984,0.1523438-0.3925781,0.3964844-0.4384766,0.671875    l-2,12c-0.0115356,0.0690308,0.0042114,0.1339111,0.006897,0.2012329    c-4.5922241,0.1856689-8.6968384,1.6426392-11.6005859,3.8928223C18.7199707,28.7699585,17.4500122,28,16,28    c-2.210022,0-4,1.789978-4,4c0,1.9599609,1.4000244,3.5799561,3.2600098,3.9299927C15.0900269,36.5999756,15,37.289978,15,38    c0,6.6300049,7.6099854,12,17,12s17-5.3699951,17-12c0-0.710022-0.0900269-1.4000244-0.2600098-2.0700073    C50.5999756,35.5799561,52,33.9599609,52,32z M22,35c0-1.6568604,1.3431396-3,3-3s3,1.3431396,3,3s-1.3431396,3-3,3    S22,36.6568604,22,35z M39.6171875,43.4970703C37.5566406,45.1113281,34.8515625,46,32,46    s-5.5566406-0.8886719-7.6171875-2.5029297c-0.4345703-0.3408203-0.5107422-0.96875-0.1699219-1.4042969    c0.3408203-0.4335938,0.96875-0.5117188,1.4042969-0.1699219C27.3261719,43.2626953,29.59375,44,32,44    s4.6738281-0.7373047,6.3828125-2.0771484c0.4355469-0.3417969,1.0634766-0.2636719,1.4042969,0.1699219    C40.1279297,42.5283203,40.0517578,43.15625,39.6171875,43.4970703z M39,38c-1.6568604,0-3-1.3431396-3-3s1.3431396-3,3-3    s3,1.3431396,3,3S40.6568604,38,39,38z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.54198dd6cfaff590dfb10e98e762bea7.svg";
export { ForwardRef as ReactComponent };